// Declaração de tipos para Google Analytics e Facebook Pixel
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Meta Pixel ID fornecido pelo time de marketing: 735009595612284

// Analytics tracking utilities
export const trackEvent = (
  eventName: string,
  parameters?: Record<string, any>
): void => {
  if (typeof window !== "undefined") {
    // Google Analytics
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, parameters);
    }

    // Facebook Pixel
    if (typeof window.fbq === "function") {
      window.fbq("track", eventName, parameters);
    }

    console.log("Event tracked:", eventName, parameters);
  }
};

// Função específica para trackear conversões (leads)
export const trackLead = (leadData?: Record<string, any>): void => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    // Evento Lead para Meta Ads otimização
    window.fbq("track", "Lead", leadData);

    // Log para debug
    console.log("Lead tracked:", leadData);
  }
};

// Função para trackear PageView (já feito automaticamente, mas pode ser usado para SPAs)
export const trackPageView = (pageName?: string): void => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView");

    // Google Analytics para SPA
    if (typeof window.gtag === "function") {
      window.gtag("config", "GA_MEASUREMENT_ID", {
        page_title: pageName,
        page_location: window.location.href,
      });
    }

    console.log("PageView tracked:", pageName || window.location.pathname);
  }
};

export const trackFormStep = (
  step: number,
  data?: Record<string, any>
): void => {
  trackEvent("Form Step Completed", {
    step: step,
    ...data,
  });
};

export const trackFormSubmission = (data: Record<string, any>): void => {
  // Trackea no Google Analytics
  trackEvent("Lead Generated", {
    user_type: data.userType,
    state: data.state,
    objective: data.objective,
    newsletter_consent: data.newsletter,
  });

  // Trackea conversão no Meta Pixel
  trackLead({
    user_type: data.userType,
    state: data.state,
    objective: data.objective,
    newsletter_consent: data.newsletter,
    value: 1, // Valor da conversão para otimização
    currency: "BRL",
  });
};

export const trackDownloadIntent = (platform: string): void => {
  trackEvent("Download Intent", {
    platform: platform,
  });
};

// Initialize analytics
export const initializeAnalytics = (): void => {
  // Facebook Pixel já está no HTML, só verificamos se foi carregado
  if (typeof window !== "undefined") {
    // Aguarda um pouco para garantir que o pixel foi carregado
    setTimeout(() => {
      if (typeof window.fbq === "function") {
        console.log("Meta Pixel loaded successfully");
      } else {
        console.warn("Meta Pixel not loaded");
      }
    }, 1000);
  }
};

export const trackModalOpen = (): void => {
  trackEvent("modal_open", {
    event_category: "engagement",
    event_label: "lead_modal",
  });
};

export const trackStepComplete = (step: number): void => {
  trackEvent("step_complete", {
    event_category: "form",
    event_label: `step_${step}`,
    step_number: step,
  });
};

export const trackLeadGenerated = (leadData: Record<string, any>): void => {
  trackEvent("generate_lead", {
    event_category: "conversion",
    event_label: "form_submit",
    user_type: leadData.tipo_usuario,
    state: leadData.estado,
    objective: leadData.objetivo,
  });

  // Trackea Lead no Meta Pixel para otimização
  trackLead({
    user_type: leadData.tipo_usuario,
    state: leadData.estado,
    objective: leadData.objetivo,
    source: "website_form",
  });
};
